// extracted by mini-css-extract-plugin
export default {"navbar":"NavBar_navbar__l-LOj","navbar-icon":"NavBar_navbar-icon__IKCi9","navbar-logo":"NavBar_navbar-logo__a9-YD"};